import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

export function useGetEscalationConfigForFacility(
    facilityId: number | null | undefined,
) {
    return useQuery({
        queryKey: [QueryKeys.eicfEscalationConfig, facilityId],
        queryFn: () => EICFTemplatesApi.getEscalationConfig(facilityId as number),
        enabled: !!facilityId && facilityId > 0,
    });
}
